/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Product Select Subscribers Table Cells
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import { EColumnCell, EColumnFilter } from '../../../../components/Table/types/columnTypes';
import { EProductSubscribersTableField } from '../../wizardProductOfferingsConstants';

export const productSelectSubscribersColumnsWidth: { [Key in EProductSubscribersTableField]: number } = {
    [EProductSubscribersTableField.ACCOUNT]: 0,
    [EProductSubscribersTableField.ACTION_CONFLICTS]: 0,
    [EProductSubscribersTableField.COST]: 0,
    [EProductSubscribersTableField.LABELS]: 0,
    [EProductSubscribersTableField.MSISDN]: 0,
    [EProductSubscribersTableField.NAME]: 0,
    [EProductSubscribersTableField.RATE_PLAN]: 0,
};

export const productSelectSubscribersColumnNames: EProductSubscribersTableField[] = [
    EProductSubscribersTableField.ACCOUNT,
    EProductSubscribersTableField.ACTION_CONFLICTS,
    EProductSubscribersTableField.COST,
    EProductSubscribersTableField.LABELS,
    EProductSubscribersTableField.MSISDN,
    EProductSubscribersTableField.NAME,
    EProductSubscribersTableField.RATE_PLAN,
];

export const getColumnFilterType = (name: string): string => {
    switch (name) {
        case EProductSubscribersTableField.ACCOUNT:
        case EProductSubscribersTableField.NAME:
        case EProductSubscribersTableField.MSISDN:
        case EProductSubscribersTableField.RATE_PLAN:
            return EColumnFilter.filterMultiSelect;
        case EProductSubscribersTableField.LABELS:
            return EColumnFilter.filterLabelMultiSelect;
        default:
            return '';
    }
};

export const getColumnCellType = (name: string): string => {
    switch (name) {
        case EProductSubscribersTableField.ACCOUNT:
            return EColumnCell.linkAccountNumber;
        case EProductSubscribersTableField.ACTION_CONFLICTS:
            return EColumnCell.actionConflicts;
        case EProductSubscribersTableField.COST:
            return EColumnCell.cost;
        case EProductSubscribersTableField.LABELS:
            return EColumnCell.labels;
        case EProductSubscribersTableField.MSISDN:
            return EColumnCell.linkMobile;
        case EProductSubscribersTableField.NAME:
        case EProductSubscribersTableField.RATE_PLAN:
        default:
            return EColumnCell.text;
    }
};

export const getColumnFixedType = (name: string): string | boolean => {
    switch (name) {
        case EProductSubscribersTableField.MSISDN:
            return 'left';
        default:
            return false;
    }
};
